//libs
import { useState, useEffect } from 'react';

function getColumnCountForWidth(width: number): number {
    if (width <= 550) {
        return 1;
    }
    if (width <= 750) {
        return 2;
    }
    if (width <= 950) {
        return 3;
    }
    return 4;
}

function readLayoutWidth(): number {
    if (typeof window === 'undefined') {
        return 1920;
    }
    return window.visualViewport?.width ?? window.innerWidth;
}

export function useColumnResize() {
    const [columnCount, setColumnCount] = useState(() =>
        typeof window === 'undefined' ? 4 : getColumnCountForWidth(readLayoutWidth())
    );

    useEffect(() => {
        const update = () => {
            const next = getColumnCountForWidth(readLayoutWidth());
            setColumnCount((prev) => (prev === next ? prev : next));
        };

        update();

        window.addEventListener('resize', update);
        window.addEventListener('orientationchange', update);
        window.visualViewport?.addEventListener('resize', update);

        return () => {
            window.removeEventListener('resize', update);
            window.removeEventListener('orientationchange', update);
            window.visualViewport?.removeEventListener('resize', update);
        };
    }, []);

    return [columnCount];
}
